export function moneyFromCents(value: unknown): string {
  const amount = Number(value ?? 0) / 100;
  return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(amount);
}

export function signedMoney(value: unknown, sign: unknown): string {
  if (value === null || value === undefined || value === '') return '-';
  const normalizedSign = String(sign ?? '').trim() === '-' ? '-' : '';
  return `${normalizedSign}${normalizedSign ? ' ' : ''}${moneyFromCents(value)}`;
}

export function signedMoneyClass(sign: unknown): string {
  return String(sign ?? '').trim() === '-' ? 'negative-amount' : '';
}

export function dateTime(value: unknown): string {
  if (!value) return '-';
  return new Date(String(value)).toLocaleString('es-AR', {
    hour12: false,
    hourCycle: 'h23'
  });
}

// GP displays the clock value supplied by the API, without converting its timezone.
export function gpDateTime(value: unknown): string {
  if (!value) return '-';
  const raw = String(value);
  const parts = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}:\d{2})(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/.exec(raw);
  if (!parts) return raw;
  const date = new Date(`${parts[1]}T${parts[2]}Z`);
  if (Number.isNaN(date.getTime())) return raw;
  return date.toLocaleString('es-AR', {
    timeZone: 'UTC',
    hour12: false,
    hourCycle: 'h23'
  });
}

export function text(value: unknown): string {
  return value === null || value === undefined || value === '' ? '-' : String(value);
}

export function statusClass(status: unknown): string {
  const value = String(status ?? '').toUpperCase();
  if (value === 'APPROVED' || value === '02') return 'badge success';
  if (value === 'DECLINED' || value === '03') return 'badge danger';
  if (value === 'VOID') return 'badge warning';
  if (value === 'REFUND') return 'badge info';
  return 'badge neutral';
}

export function brandImage(brand: unknown): string {
  return `/img/brands/${String(brand || 'unknown').toLowerCase()}.png`;
}
